<ng-container *ngIf="!verifyEmailJobSuccess && !verifyEmailJobError">
  <h6 class="mb-2 mt-2">Please verify Your Email</h6>
  <p class="text-muted">If you cannot find an email, please first try to check your spam box.</p>

  <ng-container *ngIf="localStorageEmail">
    <p>
      If this does not work, you can try to
      <a role="button" href="javascript:void(0);" (click)="resendVerificationEmail(localStorageEmail)">
        send a new verification email
      </a>
      ({{ localStorageEmail }})

      <i class="ms-2 fa fa-spinner fa-spin" *ngIf="verifyEmailLoading"></i>
    </p>
  </ng-container>
</ng-container>
<ng-container *ngIf="verifyEmailJobSuccess">
  <p class="text-center">
    A new verification email will be sent, please wait up to 5 minutes and an email should arrive.
    <i class="fa fa-envelope-o colorize text success"></i>
  </p>
</ng-container>
<ng-container *ngIf="verifyEmailJobError">
  <p>
    <span class="warning">Something unexpected happened</span><br />
    We could not resend email verification. Please contact us for assistance at
    <a href="mailto:team@enin.ai">team&#64;enin.ai</a>
  </p>
</ng-container>
